export const $ = selector => document.querySelector(selector);